import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api/v1/client`;
const CACHE_KEY = 'bootcamp_status_cache';
const CACHE_DURATION = 10 * 1000; // 10 seconds (reduced for responsiveness)

export const getBootcampStatus = async () => {
  try {
    // 1. Check Cache
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_DURATION) {
        return data;
      }
    }

    // 2. Fetch Fresh
    const res = await axios.get(`${API}/bootcamp/status`);
    const statusData = res.data;

    // 3. Update Cache
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      data: statusData,
      timestamp: Date.now()
    }));

    return statusData;
  } catch (error) {
    console.error('Error fetching bootcamp status:', error);
    // Return a default state on error to prevent UI break
    return {
      status: 'coming_soon',
      enrollmentDate: null,
      message: null
    };
  }
};
